<template>
<van-popup v-model="showPopup"
           position="bottom">
    <div class="reminder">
        <div class="top">
            <div class="reminder-title">{{ siteType === 'site' ? $t('poi.siteTips') : $t('poi.tips') }}</div>
            <div class="reminder-content">{{ content }}</div>
        </div>
        <div class="confirm-btn" @click="hide">{{ $t('common.confirm') }}</div>
    </div>
</van-popup>
</template>

<script>
import { Popup } from 'vant'
import 'vant/lib/popup/style'

export default {
    data () {
        return {
            showPopup: false
        }
    },
    props: {
        content: {
            type: String,
            default: ''
        },
        siteType: {
            type: String,
            value: ''
        }
    },
    components: {
        'van-popup': Popup
    },
    methods: {
        show () {
            this.showPopup = true
        },
        hide () {
            this.showPopup = false
        }
    }
}
</script>

<style lang="scss" scoped>
.reminder {
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   padding: 19px 0 30px;
}

.reminder .reminder-title {
    font-size: 16px;
    color: #222125;
    font-weight: bold;
    font-family: GothamBold;
    margin-bottom: 12px;
    padding: 0 12px;
    text-align: center;
}

.reminder .reminder-content {
    font-size: 14px;
    color: #888888;
    height: 214px;
    padding: 0 12px;
    overflow: auto;
}

.reminder .confirm-btn {
    width: calc(100% - 36px);
    margin: 15px auto 0;
    height: 40px;
    border-radius: 20px;
    background: #f8a909;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>